export const formatHtmlForEditor = (htmlContent, fontFamily = 'Sylfaen') => {
    const installedFonts = ["Sylfaen", "Arial", "DejaVu"];

    const container = document.createElement('div');
    container.innerHTML = htmlContent;
    Array.from(container.querySelectorAll("*")).forEach(el => {
        const currentFont = window.getComputedStyle(el).fontFamily.split(',')[0].replace(/['"]/g, '').trim();
        if (!installedFonts.includes(currentFont)) {
            el.style.fontFamily = fontFamily;
        }
        const fontSize = window.getComputedStyle(el).fontSize;
        const newFontSize = parseFloat(fontSize);
        if (!isNaN(newFontSize) && newFontSize > 0) {
            el.style.fontSize = `${newFontSize}px`;
        }
    });
    return container.innerHTML;
};
